// extracted by mini-css-extract-plugin
module.exports = {"root":"SliderBlock_root__YAZon"};